// Keep track of open popup count, to unblock refresh only when all of them are closed
import {BS} from '../../../types/BS_types'

let openPopupCount = 0
export const blockRefresh = (): unknown =>
  BS?.blockRefreshPermanently?.(`popup_${++openPopupCount}`)
export const unblockRefresh = (): unknown => BS?.unblockRefresh?.(`popup_${openPopupCount--}`)
export const getOpenPopupCount = (): number => openPopupCount
